<template>
  <Page>
    <h1>
      {{ $t("details.title") }}
      <template v-if="liability">{{liability.edges[0].node.address}}</template>
    </h1>
    <RCard v-if="liability">
      <Objective :json="liability.edges[0].node.objectiveData" />
      <section>
        <section>
          <span class="t-sm">Цифровой паспорт в Ethereum Blockchain:</span>
          <br />
          <RChainExplorer :address="liability.edges[0].node.address" />
        </section>
        <hr />
        <section>
          <span class="t-sm">Дата и время создания:</span>
          <br />
          <span>{{ new Date(liability.edges[0].node.timestamp).toLocaleString() }}</span>
        </section>
      </section>
    </RCard>
    <RLoader v-else />
  </Page>
</template>

<script>
import gql from "graphql-tag";
import Page from "../components/layout/Page";
import Objective from "./Objective";

export default {
  props: ["address"],
  components: { Page, Objective },
  data() {
    return {
      services: []
    };
  },
  apollo: {
    liability: {
      query: gql`
        query getLiability($address: String!) {
          liability: liabilities(filters: { address: $address }) {
            edges {
              node {
                id
                address
                model
                objective
                objectiveData
                result
                resultData
                promisee
                promisor
                token
                cost
                timestamp
              }
            }
          }
        }
      `,
      variables() {
        return {
          address: this.address
        };
      }
    }
  }
};
</script>
